/**
 * Created by Daniela on 23/01/2017.
 */
export const apiName: string = 'tipos-ajustes';
export const tipoAjustesRoute: string = 'tipo-ajustes';
export const tipoAjustesStorage: string = 'tipo-ajustes';
export const tipoAjustesModuleName: any = {plural: 'Tipos de ajustes', single: 'Tipo de ajuste'};

export const tipoAjustesQuery = {

};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/shared/data.service.ts
 **/